<template>
  <div class="location-card">
    <div class="location-card__col__cover__wrap">
      <div class="location-card__col__cover" v-lazy:background-image="`${col.cover}?height=${locationImageHeight*MAGNIFACATION}&lock=${index}&format=webp`"></div>
    </div>
    <div v-for="text in col.text" :key="text" class="mt-8 text-base text-grey-darkest font-medium">{{ text }}</div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'locationCard',
  props: ['col', 'index'],
  data () {
    return {
      MAGNIFACATION: 1.5
    }
  },
  computed: {
    ...mapGetters([
      'initWidth'
    ]),
    locationImageHeight () {
      if (this.initWidth >= 1200) {
        return 253
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 203
      } else if (this.initWidth < 992 && this.initWidth >= 801) {
        return 150
      } else if (this.initWidth < 801 && this.initWidth >= 768) {
        return 247
      } else if (this.initWidth < 768 && this.initWidth >= 581) {
        return 185
      } else {
        return 250
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.location-card
  &__col
    @apply relative text-center text-white p-8 flex items-center justify-center w-1/3 cursor-pointer
    &__link
      @apply w-full
    &__cover
      @apply w-full ease
      padding-top: imageRatio(150, 220)
      transform: scale(1.005)
      background:
        position: center
        repeat: no-repeat
        size: cover
      // max-width: 150px
      // max-height: 220px
      @screen md
        padding-top: imageRatio(170, 250)
        // max-width: 170px
        // max-height: 250px
      &:hover
        @apply shadow-md
        transform: scale(1.1)
      &__wrap
        @apply overflow-hidden w-full
        border-radius: 1.25rem
</style>
